import { EncryptStorage } from 'encrypt-storage';


export const encryptStorageLogin = new EncryptStorage('thisismyuniquekey', {
    prefix: '@tekie',
});